







































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { UserStoreMod } from '../store/user-store'

@Component
export default class HomePage extends Vue {
  // Makes a "exampleProperty" a component prop with the default value of 'Example'
  @Prop({ default: 'Example' }) private exampleProperty!: string;

  // Data property
  myDataProperty = 'string'
  myDataProperty2 = 'string'

  // Computed Properties
  get userName () {
    return UserStoreMod.user.name
  }

  @Watch('myDataProperty', { immediate: true, deep: true })
  onPropertyChanged (value: string, oldValue: string) {
    // Do stuff with the watcher here.
    // console.log('onPropertyChanged', value, oldValue)
    this.myDataProperty2 = (oldValue ?? '') + value
  }

  // Lifecycle hook
  created () {
    // console.log('home created')
    this.myDataProperty = 'Boop'
  }

  // Lifecycle hook
  mounted () {
    // console.log('home mounted')
  }

  // Component method
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateMyProperty ($event: any) {
    this.myDataProperty = $event.target.value
  }
}
